module.exports = __webpack_public_path__ + "static/media/map.ec4754d1.svg";